import type React from 'react'
import { createContext, useContext } from 'react'
import type { QueryClient } from './query-client'

const QueryClientContext = createContext<QueryClient | undefined>(undefined)

export interface QueryClientProviderProps {
  client: QueryClient
  children: React.ReactNode
}

export function QueryClientProvider({
  client,
  children,
}: QueryClientProviderProps) {
  return (
    <QueryClientContext.Provider value={client}>
      {children}
    </QueryClientContext.Provider>
  )
}

export function useQueryClient(): QueryClient
export function useQueryClient(
  queryClient: QueryClient | undefined,
): QueryClient
export function useQueryClient(queryClient?: QueryClient): QueryClient {
  const contextClient = useContext(QueryClientContext)
  const client = queryClient ?? contextClient
  if (!client) {
    throw new Error(
      'useQueryClient requires either a queryClient parameter or QueryClientProvider',
    )
  }
  return client
}
